import _ from 'lodash';

// Type-safe version of groupBy that ensures the key exists on the object
export const typedGroupBy = <T extends Record<string, any>, K extends keyof T>(
  collection: T[] | null | undefined,
  key: K | ((item: T) => string | number)
): Record<string, T[]> => {
  if (typeof key === 'function') {
    return _.groupBy(collection, key);
  }
  return _.groupBy(collection, key) as Record<
    T[K] extends string | number ? T[K] : never,
    T[]
  >;
};

export const typedKeyBy = <T extends Record<string, any>, K extends keyof T>(
  collection: T[] | null | undefined,
  key: K
): Record<T[K] extends string | number ? T[K] : never, T> =>
  _.keyBy(collection, key) as Record<
    T[K] extends string | number ? T[K] : never,
    T
  >;
